import { Flex, Td, Tr } from "@chakra-ui/react";
import { useMemo } from "react";
import { Exercise } from "../../models/Exercise";
import ExerciseItem from "./ExerciseItem";
import { Quiz } from "../../models/Quiz";
import QuizItem from "./QuizItem";

type Props = {
  name: string;
  exams: Exercise[];
  quizzes: Quiz[];
};

export default function ProgressRowItem({ name, exams, quizzes }: Props) {
  const sortedExams = useMemo(
    () =>
      exams?.sort((examA, examB) => (examA.position > examB.position ? 1 : -1)),
    [exams],
  );
  const { preTasks, postTasks } = useMemo(
    () =>
      quizzes.reduce<{ preTasks: Quiz[]; postTasks: Quiz[] }>(
        (p, c) => {
          p[c.schedule === "BEFORE" ? "preTasks" : "postTasks"].push(c);
          return p;
        },
        { preTasks: [], postTasks: [] },
      ),
    [quizzes],
  );

  return (
    <Tr>
      <Td>{name}</Td>
      <Td>
        <Flex direction="row" gap={2}>
          {preTasks.map((preTask, index) => (
            <QuizItem quiz={preTask} key={`pre_${index}`} index={index + 1} />
          ))}
          {sortedExams.map((exam, index) => (
            <ExerciseItem exam={exam} key={`${index}`} />
          ))}
          {postTasks.map((postTask, index) => (
            <QuizItem quiz={postTask} key={`post_${index}`} index={index + 1} />
          ))}
        </Flex>
      </Td>
    </Tr>
  );
}
